module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_3009.47aa8fa9.png";